/* @flow */
// typecheck: ignore file
import { takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { loadOrganizationClassesSuccess } from 'reducers/organizationClassesTables';
import type { LoadOrganizationClassesRequest } from 'reducers/organizationClassesTables';

import API from 'lib/RemindAPI';

type Sort = 'name' | 'created' | 'last_active';
type SortDirection = 'desc' | 'asc';

export type OrganizationClassesFetchOptions = {
  sort?: Sort,
  page: number,
  query?: string,
  perPage: number,
  sortDirection?: SortDirection,
}

function fetch(id: number | string, parameters: OrganizationClassesFetchOptions): Promise<Group[]> {
  const options = {
    sort_type: parameters.sort,
    per_page: parameters.perPage,
    sort_direction: parameters.sortDirection,
    page: parameters.page,
    q: parameters.query,
  };

  return API.request(`/organizations/${id}/classes`, 'GET', options).then(response => response.classes);
}

function* fetchOrganizationClasses(action: LoadOrganizationClassesRequest): Generator<?any, ?any, ?any> {
  try {
    const classes = yield call(fetch, action.organizationId, action.options);

    if (classes) {
      yield put(loadOrganizationClassesSuccess(action.organizationId, classes, action.options));
    }
  } catch (e) {
    console.error(e);
  }
}

export default function* organizationClasses(): Generator<?any, ?any, ?any> {
  // $FlowFixMe
  yield* takeLatest('organizationClassTables/LOAD_ORGANIZATION_CLASSES_REQUEST', fetchOrganizationClasses);
}



// WEBPACK FOOTER //
// ./src/sagas/organizationClasses.js